import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export interface GetContentCountriesResponse {
  countries: string[];
}

/** The countries present in the content, for a content filter dropdown. */
export function useGetContentCountries(token?: string) {
  const url = 'content/countries';

  const {
    data,
    error,
    mutate,
  }: {
    data?: GetContentCountriesResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(url, SWRFetcher({ method: 'GET' }, token));

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
